module.exports = __webpack_public_path__ + "img/icon_2_44.26a71884.png";